import { createContext } from 'preact';

export const blisseyParamsContext = createContext<{ currency: string; linkTarget: string }>({
  currency: 'usd',
  linkTarget: '_blank',
});
